<script>
export default {
    props: {
        fields: {
            type: [Object, Array],
            default: undefined
        },
        items: {
            type: [Array, Function],
            default: undefined
        },
        stickyHeader: {
            default: false
        },
        striped: {
            default: true
        },
        responsive: {
            default: true
        },
        bordered: {
            default: true
        },
        sortIconLeft: {
            default: true
        },
        sortBy: {
            default: null
        },
        sortDesc: {
            default: false
        },
        noLocalSorting: {
            default: true
        },
        noProviderPaging: {
            default: true
        },
        noProviderSorting: {
            default: true
        },
        noProviderFiltering: {
            default: true
        },
        hover: {
            default: true
        },
        theadClass: {
            default: null
        },
        tbodyTrClass: {
            default: null
        }
    },
    data() {
        return {
            selecionando: false,
            modoSelecao: null,
        }
    },
    methods: {
        atualizaTooltipSelecao() {
            const selectedCells = document.querySelectorAll('td.valor_soma.valor_soma_selected');
            const headerCells = document.querySelectorAll('.b-table thead th');
            headerCells.forEach(th => {
                const headerDiv = th.querySelector('div');
                if (headerDiv && !headerDiv.dataset.originalText) {
                    headerDiv.dataset.originalText = headerDiv.innerHTML;
                }
            });
            if (selectedCells.length === 0) {
                headerCells.forEach(th => {
                    const headerDiv = th.querySelector('div');
                    if (headerDiv && headerDiv.dataset.originalText) {
                        headerDiv.innerHTML = headerDiv.dataset.originalText;
                    }
                });
                return;
            }
            const somaPorColuna = {};
            selectedCells.forEach(cell => {
                const colIndex = cell.cellIndex;
                const rawText = cell.textContent;
                const cleanText = rawText
                    .replace(/R\$\s?/g, '')
                    .replace(/\./g, '')
                    .replace(',', '.');
                const valor = parseFloat(cleanText) || 0;
                somaPorColuna[colIndex] = (somaPorColuna[colIndex] || 0) + valor;
            });
            headerCells.forEach((th, index) => {
                const headerDiv = th.querySelector('div');
                if (headerDiv && headerDiv.dataset.originalText) {
                    if (somaPorColuna[index] !== undefined) {
                        let isCurrency = false;
                        if (headerDiv.dataset.originalText.indexOf("R$") !== -1) {
                            isCurrency = true;
                        } else {
                            selectedCells.forEach(cell => {
                                if (cell.cellIndex === index && cell.textContent.indexOf("R$") !== -1) {
                                    isCurrency = true;
                                }
                            });
                        }
                        let soma = somaPorColuna[index];
                        let formattedSoma = '';
                        if (isCurrency) {
                            formattedSoma = new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                                minimumFractionDigits: 2
                            }).format(soma);
                        } else {
                            formattedSoma = new Intl.NumberFormat('pt-BR', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }).format(soma);
                        }
                        headerDiv.innerHTML = `${headerDiv.dataset.originalText} (${formattedSoma})`;
                    } else {
                        headerDiv.innerHTML = headerDiv.dataset.originalText;
                    }
                }
            });
        },
        iniciaSelecao(event) {
            const td = event.target.closest('td.valor_soma');
            if (td) {
                this.selecionando = true;
                if (td.classList.contains('valor_soma_selected')) {
                    td.classList.remove('valor_soma_selected');
                    this.modoSelecao = 'deselecionar';
                } else {
                    td.classList.add('valor_soma_selected');
                    this.modoSelecao = 'selecionar';
                }
                this.atualizaTooltipSelecao();
            }
        },
        atualizarSelecao(event) {
            if (this.selecionando) {
                const td = event.target.closest('td.valor_soma');
                if (td) {
                    if (this.modoSelecao === 'selecionar') {
                        td.classList.add('valor_soma_selected');
                    } else if (this.modoSelecao === 'deselecionar') {
                        td.classList.remove('valor_soma_selected');
                    }
                }
                this.atualizaTooltipSelecao();
            }
        },
        finalizarSelecao() {
            this.selecionando = false;
            this.modoSelecao = null;
            this.atualizaTooltipSelecao();
        },
        habilitaSelecaoTexto(event) {
            if (event.detail === 2 && event.target.closest('td.valor_soma')) {
                event.target.closest('td.valor_soma').style.userSelect = 'text';
            }
        },
        alteraOrdenacao(ordenacao) {
            if (ordenacao.sortBy) {
                const filtros = {
                    sort: ordenacao.sortBy,
                    direction: ordenacao.sortDesc ? 'desc' : 'asc'
                };
                this.$parent.$parent.atualizaUrl(filtros);
            }
        },
        mostraItemMobile(item) {
            this.$modal.show(() => import('./ItenMobile.vue'), 'sm', {
                item: item,
                fields: this.$props.fields
            });
        }
    },
    render(h) {
        return h('b-table', {
            ':sort-by.sync': this.sortBy,
            ':sort-desc.sync': this.sortDesc,
            props: this.$props,
            class: this.$isMobile() ? 'remover-selecao' : '',
            slots: this.$parent.$slots,
            scopedSlots: this.$parent.$scopedSlots,
            on: {
                'sort-changed': (ordenacao) => this.alteraOrdenacao(ordenacao),
                'hook:mounted': () => {
                    const rows = document.querySelectorAll('.b-table tbody tr');
                    const body = document.querySelector('body');

                    rows.forEach((row, i) => {
                        let pressTimer = null;
                        let autoClose = false;
                        row.addEventListener('touchstart', () => {
                            autoClose = false;
                            body.setAttribute("class", "remover-selecao");
                            pressTimer = setTimeout(() => {
                                this.mostraItemMobile(this.$props.items[i]);
                            }, 400);
                        });
                        row.addEventListener('touchend', () => {
                            if (!autoClose) {
                                this.$modal.hide();
                            }
                            if (body.classList.contains("remover-selecao")) {
                                body.classList.remove("remover-selecao");
                            }
                            clearTimeout(pressTimer);
                        });
                        row.addEventListener('touchmove', () => {
                            autoClose = true;
                            clearTimeout(pressTimer);
                        });
                    });
                    const valorSomaCells = document.querySelectorAll('.b-table tbody td.valor_soma');
                    valorSomaCells.forEach(cell => {
                        cell.addEventListener('mousedown', this.iniciaSelecao);
                        cell.addEventListener('mouseover', this.atualizarSelecao);
                        cell.addEventListener('mouseup', this.finalizarSelecao);
                        cell.addEventListener('click', this.habilitaSelecaoTexto);
                    });
                }
            }
        });
    }
};
</script>

<style>
.remover-selecao {
    -webkit-user-select: none;
    /* Safari */
    -ms-user-select: none;
    /* IE 10 and IE 11 */
    user-select: none;
    /* Standard syntax */
}

td.valor_soma {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>